// extracted by mini-css-extract-plugin
module.exports = {"orderListInputContainer":"PartnerList_orderListInputContainer__3VqC-","orderListButton":"PartnerList_orderListButton__vN52_"};